const wip = {
  state: () => ({
    /** 在製品管理搜尋條件 */
    searchConditions: {},

    /** 在製品管理搜尋條件-表單形式 */
    searchDataForm: {},
  }),

  mutations: {
    /** 在製品管理搜尋條件 設值 */
    setWipSearchConditions(state, value) {
      state.searchConditions = value;
    },

    /** 在製品管理搜尋條件-表單形式 設值 */
    setSearchDataForm(state, value) {
      state.searchDataForm = value;
    },
  },
};

export default wip;
